<template>
  <div
    class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 h-full overflow-hidden"
  >
    <div
      class="
        pb-5
        border-b border-gray-200
        sm:flex
        sm:items-center
        sm:justify-between
      "
    >
      <div class="sm:w-0 sm:flex-1">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Cases Assigned
        </h3>
        <p class="mt-1 text-sm text-gray-500 overflow-hidden overflow-ellipsis">
          This is a list of cases that are currently assigned to you. <br>
          Family Defender Matter cases with FAM plan class - These matters may be paid out in accordance with the U.S. Legal Services Inc. Attorney Fee Schedule. Specific coverage will vary depending on the member’s plan. You must contact our Authorizations Department prior to proceeding with a member’s legal matter in order to determine the member’s coverage.
          <br> Family Defender Matter cases with REF plan class – These matters are referral only (non-covered legal service) due member’s plan coverage or pre-existing nature. Please provide a free consultation and bill the member directly at a discount of at least 33% off your normal hourly rate. 
          <br>CDL Defender cases (CDL plan class) with a Ticket type of “Ticket” – These cases will be paid out in accordance with your agreed upon flat rate fee for CDL cases.   
          <br>CDL Defender cases (CDL plan class) with a Ticket type of “Referral” – These cases are referral only (non-covered legal service) due member’s plan coverage or pre-existing nature. Please provide a free consultation and bill the member directly at a discount of at least 33% off your normal hourly rate. 
          
        </p>
      </div>
    </div>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <form class="mt-5 sm:flex sm:items-center">
          <div class="w-half sm:max-w-xs mr-5">
             <label
                    class="inline-flex items-center mt-3"
                  >
                    <input
                      type="radio"
                      v-model="case_type"
                      value="0"
                      class="form-radio h-5 w-5 cobalt-text-color"
                    /><span class="ml-2 text-black-100">Covered Cases</span>
                  </label>
                  <label
                    class="inline-flex items-center mt-3 ml-2"
                  >
                    <input
                      type="radio"
                      v-model="case_type"
                      value="1"
                      class="form-radio h-5 w-5 cobalt-text-color"
                    /><span class="ml-2 text-black-100">Referral</span>
                  </label>
          </div>
          <div class="w-half sm:max-w-xs mr-2">
            <label for="type" class="sr-only">Case Type</label>
            <select
              id="type"
              name="type"
              v-model="type"
              autocomplete="type"
              class="
                max-w-lg
                block
               border-barley
                w-full
                shadow-sm
                sm:max-w-xs
                sm:text-sm
                border-gray-300
                rounded-md
                py-2 ps-3 pe-10
              "
            >
              <option value="">Select Case Type</option>
              <option value="Matter">Matter</option>
              <option value="CDL">CDL</option>
            </select>
          </div>
          <div class="w-half sm:max-w-xs mr-2" v-if="type != ''">
            <label for="case_number" class="sr-only">Case Number</label>
            <input
              type="text"
              v-model="case_number"
              name="case_number"
              id="text"
              class="
                shadow-sm
               border-barley
                block
                w-full
                sm:text-sm
                border-gray-300
                rounded-md
              "
              placeholder="Enter Case Number"
            />
          </div>
          <div class="w-half sm:max-w-xs mr-2">
            <label for="member_numner" class="sr-only">Member Numner</label>
            <input
              type="text"
              v-model="member_number"
              name="member_number"
              id="text"
              class="
                shadow-sm
               border-barley
                block
                w-full
                sm:text-sm
                border-gray-300
                rounded-md
              "
              placeholder="Enter Member Number"
            />
          </div>
          <button
            type="button"
            v-on:click="search"
            class="
              mt-3
              w-full
              inline-flex
              items-center
              justify-center
              px-4
              py-2
              border border-transparent
              shadow-sm
              font-medium
              rounded-md
              text-white
             cobalt-button-color
              focus:outline-none
              focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
              sm:mt-0
              sm:ml-3
              sm:w-auto
              sm:text-sm
            "
          >
            Search
          </button>
          <button
            type="button"
            v-on:click="clearSearch"
            class="
              mt-3
              w-full
              inline-flex
              items-center
              justify-center
              px-4
              py-2
              border border-[#ce4c29]
              shadow-sm
              font-medium
              rounded-md
              text-[#1f3341]
              bg-[#ffffff]
              sm:mt-0
              sm:ml-3
              sm:w-auto
              sm:text-sm
            "
          >
            Clear
          </button>
        </form>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="-my-2 sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block w-full sm:px-6 lg:px-8">
          <div
            class="
              shadow
              overflow-auto
              border-b border-gray-200
              sm:rounded-lg
            "
          >
          
            <DataTable
              class="min-w-full divide-y divide-gray-200"
              :value="cases_list"
              :paginator="true"
              :alwaysShowPaginator="false"
              :rowsPerPageOptions=[10,20,50,70,100]
              :rows="10"
            >
              <template #empty>
                No Records Found
              </template>
              <Column field="number" header="Case#/Type" :sortable="true">
                <template #body="slotProps">
                  <div class="flex items-center">
                    <div class="ml-2">
                      <div class="text-sm font-medium text-gray-900">
                        {{ slotProps?.data?.number }}
                      </div>
                      <div class="text-sm text-gray-500">
                        {{ slotProps?.data?.type }}
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="number" header="Plan Class/Ticket Type" :sortable="true">
                <template #body="slotProps">
                  <div class="flex items-center">
                    <div class="ml-2">
                      <div v-if="slotProps?.data?.type!='CDL'" class="text-sm font-medium text-gray-900">
                        {{ slotProps?.data?.plan_class == "COM" ? "FAM" : slotProps?.data?.plan_class }}
                      </div>
                      <div v-if="slotProps?.data?.type=='CDL'" class="text-sm font-medium text-gray-900">
                        {{ slotProps?.data?.ticket_type }}
                      </div>
                     
                    </div>
                  </div>
                </template>
              </Column>
              <Column
                field="member_name"
                header="Member"
                :sortable="true"
              ></Column>
                <Column
                field="member_status"
                header="Member Status"
                :sortable="true"
              >
              <template #body="slotProps">
                  <span
                    v-if="lowercase(slotProps.data.member_status) == 'active'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                      "
                  >
                    {{ slotProps.data.member_status }}
                  </span>
                   <span
                    v-if="lowercase(slotProps.data.member_status) == 'inactive'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                      "
                  >
                    {{ slotProps.data.member_status }}
                  </span>
                   <span
                    v-if="lowercase(slotProps.data.member_status) == 'terminated'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red-100
                        text-red-800
                      "
                  >
                    {{ slotProps.data.member_status }}
                  </span>
              </template>
              </Column>
              <Column
                field="coverage"
                header="Legal Matter"
                :sortable="true"
              ></Column>
              <Column field="datecreated" header="Created" :sortable="true">
                <template #body="slotProps">
                  {{ setDateFormat(slotProps?.data?.datecreated) }}
                </template></Column
              >
              <Column field="status" header="Status" :sortable="true">
                <template #body="slotProps">
                  <span
                    v-if="lowercase(slotProps.data.status) == 'csr assigned'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'pending csr assignment'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-blue-100
                        text-blue-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="lowercase(slotProps.data.status) == 'ticket intake'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-oraange-100
                        text-orange-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="lowercase(slotProps.data.status) == 'closed'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red-100
                        text-red-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="lowercase(slotProps.data.status) == 'recruitment'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-indigo-100
                        text-indigo-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) == 'pending court date'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) == 'pending confirmation'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-blue-100
                        text-blue-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'pending rate approval'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) == 'pending trial date'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'alternative benefit offered'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red-100
                        text-red-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'pending account payment'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'pending co-pay receipt'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-indigo-100
                        text-indigo-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <!-- matter -->
                  <span
                    v-if="lowercase(slotProps.data.status) == 'void'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-gray-100
                        text-gray-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="lowercase(slotProps.data.status) == 'pending'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-blue-100
                        text-blue-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) == 'assigned to attorney'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="lowercase(slotProps.data.status) == 'authorized'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                  <span
                    v-if="
                      lowercase(slotProps.data.status) ==
                        'mobile/web submission'
                    "
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-purple-100
                        text-purple-800
                      "
                  >
                    {{ slotProps.data.status }}
                  </span>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showPopup" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h1 class="text-center text-2xl font-semibold mb-4" style="color: #1f3341;">
          2025 Fee for Services Network Attorney Agreement
        </h1>
        <p class="text-gray-800 font-bold">
          We’re excited to share that U.S. Legal Services has updated and enhanced our Attorney Fee Reimbursement Schedule—designed with you in mind to offer greater overall compensation for the valuable work you do.<br />
          <br />
          The new schedule goes into effect on June 9, 2025. Please note that any matters authorized before that date will be paid based on the prior fee schedule, while all matters assigned and authorized on or after June 9 will follow the updated rates outlined in the below link.<br />
          <br />
          Please click the following link to review and sign the new Fee for Services Network Attorney Agreement and Fee Schedule:
          <a  href="#"
          @click.prevent="handleFeeAgreementClick"
          class="text-blue-500 hover:underline">Click here</a>
        </p>
        <button @click="dismissPopup" class="mx-auto px-4 py-2 bg-[#1f3341] text-white rounded-lg hover:bg-[#1f3341] block">Close</button>
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import Constants from "../../constants.ts"; // importing constant resubale variables.
import { checkFeeAgreementStatus, generateDynamicLink } from '@/utils/feeAgreementPopup';
export default {
  name: "AuthList",
  data() {
    return {
      showPopup: false,
      case_number: null,
      member_number: null,
      type: "",
      case_type: "0",
      status: "",
      setDateFormat: Constants.setDateFormat,
    };
  },
  computed: {
  ...mapState(["cases_list"]),
  attid() {
      return this.$store._state.data.att_user.data.id;
    },
  },
  async mounted() {
    const attid = this.attid || this.$store.state.profile_data.attid;
    const isSelected = await checkFeeAgreementStatus(this.$store);
    const dismissed = localStorage.getItem('feeAgreementPopupDismissed');
    this.showPopup = !isSelected && !dismissed;
    this.dynamicLink = await generateDynamicLink(attid);
  $("body, html").animate({ scrollTop: 0 }, 1000);
    this.$store.dispatch("getCases");
  },
  created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value != null) {
          if (value.message == "Authorization failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            setTimeout(() => {
              this.$router.push({ name: "Login" });
            }, 500);
          }
        }
      }
    );
  },
  methods: {
    dismissPopup() {
    this.showPopup = false;
    localStorage.setItem('feeAgreementPopupDismissed', 'true');
  },
    handleFeeAgreementClick() {

      // setTimeout(() => {
        // this.logoutUser();
        this.$store.dispatch("logout");

        // window.open(this.dynamicLink);
        window.location.href = this.dynamicLink;
      // }, 500);
    },
    lowercase: function(string) {
      if (string != null && string != "") {
        return string.toLowerCase();
      }
    },
    clearSearch: function() {
      this.case_number = null;
      this.member_number = null;
      this.type = "";
      this.case_type = "0";
      this.status = "";
      this.$store.dispatch("getCases");
    },
    search: function() {
      this.$store.dispatch("getCases", {
        type: this.type,
        case_type: this.case_type,
        status: this.status,
        case_number: this.case_number,
        member_number: this.member_number,
      });
    },
  },
};
</script>
